export default __webpack_public_path__ + "static/media/logo.e5006583.png";